import React, { useContext } from "react";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { Paper, Box, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { personnelListContext } from "../../PersonnelListPage";
import { NormalText } from "../../../../components/TextParts";
import OverflowX from "../../../../components/OverflowX";

const columnsFromCondition = [
  { field: "id", headerName: "ID", width: 100, sortable: false, headerAlign: "left" },
  { field: "belonging_flag_label", headerName: "商流の程度", width: 150, sortable: false, headerAlign: "left" },
  { field: "cost_high", headerName: "単価(万円)", type: "number", width: 150, headerAlign: "left" },
  { field: "age", headerName: "年齢", type: "number", width: 110, headerAlign: "left" },
  { field: "actual_work", headerName: "稼働開始予定", width: 200, sortable: false, headerAlign: "left" },
  {
    field: "cost_high_smallScreen",
    headerName: "単価(万円)",
    type: "number",
    width: 100,
    headerAlign: "center",
    valueGetter: (params) => params.row?.cost_high,
  },
  {
    field: "age_smallScreen",
    headerName: "年齢",
    type: "number",
    width: 100,
    headerAlign: "center",
    valueGetter: (params) => params.row?.age,
  },
  {
    field: "actual_work_smallScreen",
    headerName: "稼働開始予定",
    width: 220,
    sortable: false,
    headerAlign: "center",
    valueGetter: (params) => params.row?.actual_work,
  },
];

const columnsFromRecruitment = [
  {
    field: "match_ratio",
    headerName: "マッチ率",
    headerAlign: "center",
    width: 100,
    align: "center",
    valueGetter: ({ value }) => `${Math.round(value || 0)}%`,
  },
  {
    field: "match_ratio_smallScreen",
    headerName: "マッチ率",
    headerAlign: "center",
    width: 100,
    align: "center",
    valueGetter: (params) => `${Math.round(params.row?.match_ratio || 0)}%`,
  },
  ...columnsFromCondition,
];

const dataGridStyles = {
  ".MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
  "& .MuiDataGrid-row:hover": { boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.3)", zIndex: 1 },
  "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": { outline: "none" },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
    outline: "2px solid #fff",
    outlineOffset: "-2px",
  },
  " .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
  fontSize: "14px",
};

export default function PersonnelListFromRecruitment() {
  const {
    allCount = 0,
    listFromRecruitment = [],
    formdataFromRecruitment = {},
    setIsBottom,
  } = useContext(personnelListContext);

  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const navigate = useNavigate();

  const visibleColumns = isSmallScreen
    ? [
        "match_ratio_smallScreen",
        "cost_high_smallScreen",
        "age_smallScreen",
        "actual_work_smallScreen",
      ]
    : [
        "match_ratio",
        "id",
        "belonging_flag_label",
        "cost_high",
        "age",
        "actual_work",
      ];

  const handleRowClick = (params) => {
    const index = listFromRecruitment.findIndex(({ id }) => id === params.row.id);
    navigate("/personnelDetail", {
      state: {
        transitionSorce: "personnelListFromProject",
        personnelId: params.row.id,
        projectId: formdataFromRecruitment.project_id,
        postData: {
          params: {
            ...formdataFromRecruitment,
            offset: Math.max(0, index - 1),
          },
        },
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <NormalText text={`検索結果: ${allCount} 件`} />
      </Box>
      <OverflowX minWidth={600} setIsBottom={setIsBottom}>
        <Paper sx={{ flexGrow: 1 }}>
          <DataGrid
            rows={listFromRecruitment}
            columns={columnsFromRecruitment.filter((column) =>
              visibleColumns.includes(column.field)
            )}
            onRowClick={handleRowClick}
            hideFooter
            disableColumnSelector
            disableColumnFilter
            disableColumnMenu
            disableSelectionOnClick
            autoHeight
            localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
            sx={dataGridStyles}
          />
        </Paper>
      </OverflowX>
    </Box>
  );
}